//region :: Imports ::
import {CreateWorkerRequest, UpdateWorkerRequest, WorkerClient, WorkerHubClientConfiguration} from '../Api/WorkerHubClients';
import {CreateWorkerReply, UpdateWorkerReply, WorkerListReply, WorkerLookupReply, WorkerReply} from './WorkerHubTypes';
import MServiceBase from '../Toolkit/ServiceBase';
import MInvokeObjectResult from '../Toolkit/InvokeObjectResult';
import InvokeObjectResult from '../Toolkit/InvokeObjectResult';
import {forEachProperty} from '../Toolkit/Utils';
import {IMsalContext} from '@azure/msal-react';

//endregion

/** */
class WorkerService extends MServiceBase {

    private readonly m_workerClient: WorkerClient;

    /** */
    public constructor(msalContext: IMsalContext) {
        super();

        this.m_workerClient = new WorkerClient(
            new WorkerHubClientConfiguration(msalContext), process.env.REACT_APP_WORKERHUB_API);

    }

    /** */
    public async get(workerId: string): Promise<InvokeObjectResult<WorkerReply>> {

        return await this.invokeReply<WorkerReply>(async() =>
            forEachProperty(new WorkerReply(), await this.m_workerClient.get(workerId)));

    }

    /** */
    public async getOrgDetails(workerId: string): Promise<InvokeObjectResult<WorkerLookupReply>> {

        return await this.invokeReply<WorkerLookupReply>(async() =>
            forEachProperty(new WorkerLookupReply(), await this.m_workerClient.getOrgDetails(workerId)));
    }

    /** */
    public async getManagerDetails(workerId: string): Promise<InvokeObjectResult<WorkerLookupReply>> {

        return await this.invokeReply<WorkerLookupReply>(async() =>
            forEachProperty(new WorkerLookupReply(), await this.m_workerClient.getManagerDetails(workerId)));
    }

    /** */
    public async getAll(): Promise<MInvokeObjectResult<WorkerListReply>> {

        return await this.invokeReply<WorkerListReply>(async() =>
            forEachProperty(new WorkerListReply(), await this.m_workerClient.getAll()));

    }

    /** */
    public async create(request: CreateWorkerRequest): Promise<InvokeObjectResult<CreateWorkerReply>> {

        return await this.invokeReply<CreateWorkerReply>(async() =>
            forEachProperty(new CreateWorkerReply(), await this.m_workerClient.post(request)));

    }

    /** */
    public async update(workerId: string, request: UpdateWorkerRequest): Promise<InvokeObjectResult<UpdateWorkerReply>> {

        return await this.invokeReply<UpdateWorkerReply>(async() =>
            forEachProperty(new UpdateWorkerReply(), await this.m_workerClient.update(workerId, request)));
    }

}

export default WorkerService;
